import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'
import ModalController from 'webmodals/modal.controller'
import utils from 'emun.on-demand/lib/util'
import templateUrl from 'emun.on-demand/confirmations/image-resolution-confirmation.htm'

class ImageResolutionConfirmationController extends ModalController {
    constructor($uibModalInstance, images, options) {
        super($uibModalInstance)
        const $ctrl = this;
        Object.assign($ctrl, options);
        $ctrl.images = images;
        $ctrl.dismiss = $ctrl.cancel = $uibModalInstance.dismiss;
        $ctrl.close = $ctrl.ok = $uibModalInstance.close;
    }
}

export default {
    open(options) {
        const $q = resolve('$q');
        let images = options.design.objects
            .map(img => Object.assign({ scale: 100 * Math.max(img.scaleX, img.scaleY) }, img, utils.splatName(img.layerId || '')))
            .filter(img => img.isImage && (img.scaleX > 1 || img.scaleY > 1));

        if (!images.length) return $q.when(true);
        images.forEach(o => options.design.validationMessages.push('Image Oversized: ' + (o.layerId || o.name || o.type)));
        let mi = modals.open(Object.assign({
            templateUrl,
            resolve: {
                options: () => options,
                images: () => images
            },
            bindToController: true,
            controller: ImageResolutionConfirmationController,
            controllerAs: '$ctrl'
        }, options.modal));
        return mi.result;
    }
};